export default __webpack_public_path__ + "static/media/bg-dark-mid.a038c564.png";